/* RAJ product page: details tabs stay closed until a tab is clicked; clicking the open tab closes it again. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var head = e.target && e.target.closest && e.target.closest('.sf-pdt__accordion .sf-tab-header');
    if (!head) return;
    var wrap = head.closest('.sf-pdt__accordion');
    var wasOpen = wrap.classList.contains('raj-open') && head.classList.contains('active');
    wrap.classList.toggle('raj-open', !wasOpen);
    wrap.querySelectorAll('.sf-tab-header').forEach(function (h) { h.setAttribute('aria-expanded', String(!wasOpen && h === head)); });
  }, true);
  function prep() {
    document.querySelectorAll('.sf-pdt__accordion .sf-tab-header').forEach(function (h) {
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-expanded', 'false');
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); h.click(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prep); else prep();
})();
